/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Invite_SelectedInputs */

const cs_users_invite_selected = /** @type {(inputs: Users_Invite_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslat pozvánku vybraným`)
};

const en_users_invite_selected = /** @type {(inputs: Users_Invite_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite selected`)
};

/**
* | output |
* | --- |
* | "Invite selected" |
*
* @param {Users_Invite_SelectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_invite_selected = /** @type {((inputs?: Users_Invite_SelectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Invite_SelectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_invite_selected(inputs)
	return cs_users_invite_selected(inputs)
});